import { clearRecaptchaToken } from 'reduxModules/app'
import { captchaRequest, contactRequest, types } from './'
import notifications, {
  toastError,
  toastFailure,  toastSuccess
} from '../../../global/notifications'

export const dispatchContactRequest = (dispatch, data) =>
  dispatch(contactRequest(data))

export const dispatchCaptchaRequest = (dispatch, data) =>
  dispatch(captchaRequest(data))

export const onApprovedSubmit = (dispatch, data, resetForm) => {
  dispatchContactRequest(dispatch, data).then(([_, res]) => {
    if (res.type === types.CONTACT_REQUEST_SUCCESS) {
      toastSuccess(notifications.messageSent)
      if (resetForm) resetForm()
    } else
      toastFailure(notifications.messageSent, res.payload)
  })
}

export default (dispatch) => ({
  verifyRecaptcha: (data, callbackFunction, resetForm) =>
    dispatchCaptchaRequest(dispatch, {
      token: data?.recaptcha.token,
      version: data?.recaptcha.version
    })
      .then(([_, res]) => {
        if (res.type === types.CAPTCHA_REQUEST_SUCCESS)
          callbackFunction(dispatch, data, resetForm)
        else
          toastFailure(notifications.captchaVerification, res.payload)
      })
      .catch(() => toastError(notifications.captchaVerification))
      .finally(() => dispatch(clearRecaptchaToken()))
})
